<template>
  <span>
    {{ salaryFormatted }}
  </span>
</template>

<script>
import useNumberFormatter from '@/compositions/useNumberFormatter';
import {
  toRefs,
  watch,
  ref,
} from '@vue/composition-api';

export default {
  name: 'VacancySalary',
  props: {
    salary: {
      required: true,
      validator: (value) => value instanceof Object || value === null || value === undefined,
    },
  },
  setup(props) {
    const { formatSalary } = useNumberFormatter();
    const { salary } = toRefs(props);

    const salaryFormatted = ref(null);
    watch(
      salary,
      (s) => {
        salaryFormatted.value = formatSalary(s);
      },
      { immediate: true },
    );

    return {
      salaryFormatted,
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  from: from
  to: to
  notProvided: not provided
  year: per year
  month: per month
  week: per week
  day: per day
  hour: per hour
  net: net
  gross: gross
</i18n>

<i18n locale="ru" lang="yaml">
  from: от
  to: до
  notProvided: не указана
  year: в год
  month: в месяц
  week: в неделю
  day: в день
  hour: в час
  net: до вычета НДФЛ
  gross: на руки
</i18n>
